module.exports = __webpack_public_path__ + "static/media/solar.959d2671.png";